import React, { useState, useCallback } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';

import DetailTemplate from '../../components/common/template/DetailTemplate';
import DashboardTemplate from '../../components/dashboard/DashboardTemplate';
import DashboardApprovalContainer from './approval/DashboardApprovalContainer';
import DashboardCalendarContainer from './calendar/DashboardCalendarContainer';
import NoticeTemplate from '../../components/dashboard/notice/NoticeTemplate';

const DashboardContainer = () => {
  const [calFullTyp, setCalFullTyp] = useState(false);
  const [appLineToggle, setAppLineToggle] = useState(false);
  const { user } = useSelector(({ auth }) => ({
    user: auth.user, //user정보
  }));

  const handleAppLineToggle = () => {
    setAppLineToggle(!appLineToggle);
  };

  const toggleCalFull = useCallback(() => {
    setCalFullTyp(!calFullTyp);
  }, [calFullTyp]);

  return calFullTyp ? (
    <DashboardTemplate user={user}>
      <DetailTemplate title="스케줄 관리">
        <DashboardCalendarContainer toggleCalFull={toggleCalFull} full />
      </DetailTemplate>
    </DashboardTemplate>
  ) : (
    <DashboardTemplate user={user}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid item xs={6}>
            <DetailTemplate title="스케줄 관리">
              <DashboardCalendarContainer toggleCalFull={toggleCalFull} />
            </DetailTemplate>
          </Grid>
          <Grid item xs={6}>
            <DetailTemplate title="공지사항">
              <NoticeTemplate />
            </DetailTemplate>
          </Grid>
        </Grid>
      </Grid>
      <DetailTemplate title="내 결재함">
        <DashboardApprovalContainer />
      </DetailTemplate>

      {/* <DetailTemplate title="결재선 관리">
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 1 }}>
          <Button variant="outlined" onClick={handleAppLineToggle}>결제선 {appLineToggle ? `추가 닫기` : `추가`}</Button>
        </Box>
        <ApprovalListContainer />
        {appLineToggle && (
          <ApprovalFormContainer />
        )}
      </DetailTemplate>
      <DetailTemplate title="프로젝트 리스트">
        <ProjectListContainer pageUrl={projectPageUrl} />
      </DetailTemplate>
      <DetailTemplate title="유지보수 리스트">
        <MaintanceListContainer pageUrl={maintancePageUrl} />
      </DetailTemplate>
      <DetailTemplate title="세금계산서 리스트">
        <TaxbillListContainer />
      </DetailTemplate> */}
      {/* <DetailTemplate title="스케줄 확인">
      <DashboardCalendarContainer />
    </DetailTemplate> */}
    </DashboardTemplate>
  );
};

export default DashboardContainer;
